"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SPINNER_COLORS = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.array.fill");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _v = _interopRequireDefault(require("uuid/v4"));

var _classes = _interopRequireDefault(require("@nerdwallet/base-styles/classes"));

var _variables = require("@nerdwallet/base-styles/variables");

var _deprecate = require("@nerdwallet/deprecate");

var _genericSpinnerModule = _interopRequireDefault(require("./generic-spinner.module.less"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var PRESET_COLORS = {
  green: {
    background: 'green-lighter',
    fill: 'green'
  },
  'green-light': {
    background: 'green-lightest',
    fill: 'green-lighter'
  },
  grey: {
    background: 'neutral-dark',
    fill: 'neutral-darker'
  },
  white: {
    background: 'neutral-lighter',
    fill: 'neutral-lightest'
  }
};
var SPINNER_COLORS = Object.keys(PRESET_COLORS);
exports.SPINNER_COLORS = SPINNER_COLORS;

var getStrokeColors = function getStrokeColors(color) {
  var _PRESET_COLORS$color = PRESET_COLORS[color],
      background = _PRESET_COLORS$color.background,
      fill = _PRESET_COLORS$color.fill;
  return {
    background: _variables.colors[background],
    fill: _variables.colors[fill]
  };
};

var GenericSpinner = function GenericSpinner(props) {
  (0, _deprecate.useDeprecatedPropsWarning)({
    component: 'GenericSpinner',
    deprecatedProps: [{
      version: '6.5.0',
      deprecated: 'height',
      migration: 'Use "size" instead'
    }, {
      version: '6.5.0',
      deprecated: 'width',
      migration: 'Use "size" instead'
    }],
    props: props
  });
  var color = props.color,
      inline = props.inline,
      strokeWidth = props.strokeWidth,
      sizeProp = props.size,
      height = props.height; // determine the size. maintain backwards compatibility
  // props.height & props.width have been deprecated in favor of size
  // use props.height if provided over props.size since props.size now has the default prop value

  var size = height || sizeProp; // this is constant and manually calibrated with the
  // stroke-dasharray and stroke-dashoffset rules in the css

  var viewBoxSize = 42; // center of the circle is center of the viewBox

  var center = viewBoxSize / 2; // calculate the stroke width proportional to the viewBox size
  // so that the strokeWidth supplied as a prop to this Component
  // is displayed visually as close to that value as possible
  // this is done in order to compensate for the svg scaling relative to viewBox

  var scaledStrokeWidth = strokeWidth * viewBoxSize / size; // radius of the circle is half the width of the viewbox

  var radius = viewBoxSize / 2; // the stroke-width is drawn at twice the calculated size
  // on either side of the path along the radius
  // the part drawn on the outside is then clipped
  // so that only the inset stroke remains
  //
  // that uses an svg clipPath definition refered to by id
  // the clipPath definition is constant in relation to viewbox size
  // create an id in that context to prevent id clashes on the definition

  var _useState = (0, _react.useState)("clip-circle-".concat(viewBoxSize)),
      _useState2 = _slicedToArray(_useState, 2),
      clipPathId = _useState2[0],
      setClipPathId = _useState2[1]; // additionally, safari bugs out when there are multiple spinners in play
  // and one gets removed (removing the clipPath def and visually bugging out
  // any other instances on the page.
  // As a workaround, make the id universally unique browser-side
  // ... only do this browser-side to prevent server/client hydrate mismatch


  (0, _react.useEffect)(function () {
    return setClipPathId(function (oldClipPathId) {
      return "".concat(oldClipPathId, "-").concat((0, _v["default"])());
    });
  }, []);
  var colors = getStrokeColors(color);
  return _react["default"].createElement("div", {
    className: (0, _classes["default"])({
      'display-inline-block': inline,
      'display-block': !inline
    }),
    style: {
      width: size,
      height: size
    }
  }, _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 ".concat(viewBoxSize, " ").concat(viewBoxSize) // allow overflow so half pixels in a scaled viewbox don't get cut off
    ,
    style: {
      overflow: 'visible'
    }
  }, _react["default"].createElement("defs", null, _react["default"].createElement("clipPath", {
    id: clipPathId
  }, _react["default"].createElement("circle", {
    cx: center,
    cy: center,
    r: radius
  }))), _react["default"].createElement("g", null, _react["default"].createElement("circle", {
    fill: "none",
    stroke: colors.background,
    cx: center,
    cy: center,
    r: radius,
    clipPath: "url(#".concat(clipPathId, ")"),
    strokeWidth: scaledStrokeWidth * 2
  }), _react["default"].createElement("circle", {
    className: _genericSpinnerModule["default"].pathFill,
    fill: "none",
    stroke: colors.fill,
    cx: center,
    cy: center,
    r: radius,
    clipPath: "url(#".concat(clipPathId, ")"),
    strokeWidth: scaledStrokeWidth * 2
  }))));
};

GenericSpinner.defaultProps = {
  color: 'green',
  inline: false,
  size: 24,
  strokeWidth: 4
};
GenericSpinner.propTypes = {
  color: _propTypes["default"].oneOf(SPINNER_COLORS),
  inline: _propTypes["default"].bool,
  // size of spinner box in px
  size: _propTypes["default"].number,
  // width of the circle border path
  // e.g. similar to a border-width value
  strokeWidth: _propTypes["default"].number,
  // DEPRECATED
  // eslint-disable-next-line react/require-default-props
  height: _propTypes["default"].number,
  // eslint-disable-next-line react/no-unused-prop-types,react/require-default-props
  width: _propTypes["default"].number
};
var _default = GenericSpinner;
exports["default"] = _default;